<template>
  <div>
    <div style="">订单管理</div>
    <div class="mt50">
      <el-tabs v-model="tab" @tab-click="tabChange">
        <el-tab-pane label="所有订单" name=""></el-tab-pane>
        <el-tab-pane label="待确认" name="1"></el-tab-pane>
        <el-tab-pane label="生产中" name="2"></el-tab-pane>
        <el-tab-pane label="已发货" name="3"></el-tab-pane>
        <el-tab-pane label="售后" name="5"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div></div>

      <el-input
        style="width: 336px"
        v-model="search.order_merchants_no"
        placeholder="请输入商品名称或订单号"
      >
      </el-input>

      <el-button clearable class="ml20" type="primary" @click="searchList"
        >搜索</el-button
      >
    </div>

    <!--        订单列表-->
    <!--        表头-->

    <div class="fr ac fz12 mt30 pl20 pr20">
      <div style="width: 240px">产品信息</div>
      <div class="center" style="width: 150px">产品规格</div>
      <div class="center" style="width: 110px">配套工艺</div>
      <div class="center" style="width: 88px">产品价格</div>
      <div class="center" style="width: 88px">数量</div>
      <div class="center" style="width: 88px">小计</div>
      <div class="center" style="width: 88px">操作</div>
    </div>

    <el-divider></el-divider>

    <!--        列表-->

    <div class="order-list fz12" v-if="tab != 5">
      <div
        class="order-item mt20"
        style="border: 1px solid #e5e5e5"
        v-for="(item, index) in order_list"
        :key="index"
      >
        <!--                上-->
        <div style="background-color: #f0f6ff; padding: 14px">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_merchants_no }}</span>
          <span class="ml40" style="color: #4589f6">{{
            item.order_state | filterOrderState
          }}</span>
        </div>
        <!--                中-->

        <div class="fr ac" style="border-bottom: 1px solid #e5e5e5">
          <div class="">
            <div
              class="fr jc ac"
              style="
                height: 138px;
                border-right: 1px solid #e5e5e5;
                border-bottom: 1px solid #e5e5e5;
                margin-bottom: -1px;
              "
              v-for="(goods, i) in item.orderGoodsBeans"
              :key="i"
            >
              <div style="width: 270px" class="fr ac p20">
                <div class="">
                  <img
                    class=""
                    style="width: 80px; height: 80px; display: inline-block"
                    :src="goods.goods_img"
                    alt=""
                  />
                </div>

                <a class="ml10" style="width: 150px"
                  >{{ goods.goods_name }} {{ goods.goods_standard_name }}</a
                >
              </div>
              <div class="center" style="width: 150px">
                {{ goods.goods_type == 1 ? "-" : goods.specification_name }}
              </div>

              <div class="center cursor" style="width: 88px; color: #458ef6">
                {{ goods.goods_type == 1 ? goods.goods_craft_price : "-" }}
              </div>
              <div class="center" style="width: 88px">
                {{ goods.goods_price }}
              </div>
              <div class="center" style="width: 88px">
                {{ goods.goods_num }}
              </div>
              <div class="center" style="width: 88px; color: #fa6400">
                {{ goods.goods_total_price }}
              </div>
            </div>
          </div>

          <div class="fc jc ac" style="width: 100%">
            <div
              @click="
                go(
                  `/merchantsOrder/detail?order_merchants_id=${item.order_merchants_id}`
                )
              "
              v-if="item.order_state == 1"
              class="mt20 blue cursor"
            >
              确认接单
            </div>
            <div
              @click="rejectOrder(item.order_merchants_id)"
              v-if="item.order_state == 1"
              class="mt20 blue cursor"
            >
              放弃此单
            </div>
            <div
              @click="toSend(item)"
              v-if="item.order_state == 2"
              class="mt20 blue cursor"
            >
              发货
            </div>
            <div
              v-if="item.order_state == 3"
              @click="toLogistics(item.order_merchants_id)"
              class="mt20 blue cursor"
            >
              查看物流
            </div>
          </div>
        </div>

        <!--                下-->
        <div class="p20 fz14" style="text-align: right">
          <div>
            <span>订单金额</span>
            <span style="color: #458ef6">￥{{ item.order_total_price }}</span>
          </div>
          <!--                    <div style="margin-top: 6px">-->

          <!--                        <span>已付款</span>-->
          <!--                        <span>￥1000.00</span>-->
          <!--                    </div>-->
          <!--                    <div style="margin-top: 6px">-->

          <!--                        <span>未付款</span>-->
          <!--                        <span style="color: #E81C13">￥1000.00</span>-->
          <!--                    </div>-->
        </div>
      </div>
    </div>

    <!--    售后订单那列表-->
    <div class="order-list fz12" v-if="tab == 5">
      <div
        class="order-item mt20"
        style="border: 1px solid #e5e5e5"
        v-for="(item, index) in order_list"
        :key="index"
      >
        <!--                上-->
        <div style="background-color: #f0f6ff; padding: 14px">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_merchants_no }}</span>
          <span class="ml40" style="color: #4589f6">{{
            item.is_feedback == 1 ? "已处理" : "待处理"
          }}</span>
        </div>
        <!--                中-->

        <div class="fr ac" style="border-bottom: 1px solid #e5e5e5">
          <div class="">
            <div
              class="fr jc ac"
              style="
                height: 138px;
                border-right: 1px solid #e5e5e5;
                border-bottom: 1px solid #e5e5e5;
                margin-bottom: -1px;
              "
              v-for="(goods, i) in item.orderGoodsBeans"
              :key="i"
            >
              <div style="width: 270px" class="fr ac p20">
                <div class="">
                  <img
                    class=""
                    style="width: 80px; height: 80px; display: inline-block"
                    :src="goods.goods_img"
                    alt=""
                  />
                </div>

                <a class="ml10" style="width: 150px"
                  >{{ goods.goods_name }} {{ goods.goods_standard_name }}</a
                >
              </div>
              <div class="center" style="width: 150px">
                {{ goods.goods_type == 1 ? "-" : goods.specification_name }}
              </div>

              <div class="center cursor" style="width: 88px; color: #458ef6">
                {{ goods.goods_type == 1 ? goods.goods_craft_price : "-" }}
              </div>
              <div class="center" style="width: 88px">
                {{ goods.goods_price }}
              </div>
              <div class="center" style="width: 88px">
                {{ goods.goods_num }}
              </div>
              <div class="center" style="width: 88px; color: #fa6400">
                {{ goods.goods_total_price }}
              </div>
            </div>
          </div>

          <div class="fc jc ac" style="width: 100%">
            <div
              @click="
                go(
                  `/merchantsOrder/reply?order_merchants_id=${item.order_merchants_id}&is_feedback=1`
                )
              "
              v-if="item.is_feedback != 1"
              class="mt20 blue cursor"
            >
              立即处理
            </div>

            <div
              @click="
                go(
                  `/merchantsOrder/reply?order_merchants_id=${item.order_merchants_id}&is_feedback=1`
                )
              "
              v-if="item.is_feedback == 1"
              class="mt20 blue cursor"
            >
              已处理
            </div>
          </div>
        </div>

        <!--                下-->
        <div class="p20 fz14" style="text-align: right">
          <div>
            <span>订单金额</span>
            <span style="color: #458ef6">￥{{ item.order_total_price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fr jc ac mt30 mb30">
      <el-pagination
        background
        :current-page.sync="pagination.page"
        layout="prev, pager, next"
        @current-change="onPageChange"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "",
      order_list: [],
      pagination: {
        page: 1,
        total: 0,
      },
      search: {
        order_merchants_no: "",
      },
      //  反馈弹窗
      feedback_show: false,
    };
  },
  filters: {
    filterOrderState(v) {
      if (v == 1) {
        return "待确认";
      }
      if (v == 2) {
        return "生产中";
      }

      if (v == 3) {
        return "已发货";
      }
    },
  },
  mounted() {
    let param = this.$route.query;

    if (param.order_state) {
      this.tab = param.order_state;
    }

    this.getOrderList();
  },
  methods: {
    toLogistics(order_merchants_id) {
      this.$router.push({
        path: "/merchantsOrder/logistice",
        query: {
          order_merchants_id: order_merchants_id,
        },
      });
    },
    //搜索
    searchList() {
      this.page = 1;
      if (this.tab == 5) {
        this.getFeedbackOrderList();
        return;
      }
      this.getOrderList();
    },

    //发货
    toSend(order) {
      this.$router.push({
        path: "/merchantsOrder/send",
        query: {
          order: order,
        },
      });
    },

    //拒绝订单
    rejectOrder(order_merchants_id) {
      this.$confirm("是否放弃此订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            order_merchants_id: order_merchants_id,
          };
          this.post("orderInterfaces/v1.0/merchantsRefuseOrder", param).then(
            (res) => {
              this.$message("拒绝成功");

              this.getOrderList();
            }
          );
        })
        .catch(() => {});
    },
    //分页
    onPageChange(v) {
      if (this.tab == 5) {
        this.getFeedbackOrderList();
        return;
      }
      this.getOrderList();
    },
    //订单类型切换
    tabChange() {
      if (this.tab == 5) {
        this.pagination.page = 1;
        this.getFeedbackOrderList();
        return;
      }
      this.getOrderList();
    },
    //获取订单列表
    getOrderList() {
      let param = {
        order_state: this.tab == 0 ? "" : this.tab,
        page: this.pagination.page,
        order_merchants_no: this.search.order_merchants_no,
      };
      this.post("orderInterfaces/v1.0/getMerchantsOrders", param).then(
        (res) => {
          this.order_list = res.data;
          this.pagination.total = res.total;
        }
      );
    },

    //获取售后订单列表
    getFeedbackOrderList() {
      let param = {
        page: this.page,
        order_merchants_no: this.search.order_merchants_no,
      };
      this.post("orderInterfaces/v1.0/getFeedbackOrderMerchantss", param).then(
        (res) => {
          this.order_list = res.data;
          this.total = res.total;
        }
      );
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/page/me/merchantsOrder/index.vue